module.exports = __webpack_public_path__ + "img/station polaire.2cdb610c.png";